/**
 * generatedRoutePrefetchMap.ts — AUTO-GENERATED by generate-route-prefetch-map.mjs
 *
 * DO NOT EDIT MANUALLY. Re-generate with:
 *   node apps/dashboard/scripts/generate-route-prefetch-map.mjs
 *
 * Maps route paths to their lazy-chunk dynamic-import factories for
 * prefetch-on-hover via usePrefetchRoute.
 *
 * @see specs/prd.md FR-021
 */

export const ROUTE_PREFETCH_MAP: Record<string, () => Promise<unknown>> = {
  "/refine": () => import("../screens/workspace/RefinementsList"),
  "/workspace/:slug/refinements": () => import("../screens/workspace/RefinementsList"),
  "/workspaces": () => import("../screens/workspaces/WorkspaceList"),
  "/initiatives/import": () => import("../screens/initiatives/ImportPlan"),
  "/tasks": () => import("../screens/task/TaskList"),
  "/insights": () => import("../screens/insights/ActivityOverview"),
  "/insights/spending": () => import("../screens/insights/SpendingOverview"),
  "/insights/spending/:id": () => import("../screens/insights/SpendingDrilldown"),
  "/insights/quality": () => import("../screens/insights/QualityAlerts"),
  "/insights/ci": () => import("../screens/insights/CIVisualisation"),
  "/insights/friction": () => import("../screens/insights/FrictionAnalytics"),
  "/insights/assignment": () => import("../screens/insights/AssignmentConsole"),
  "/insights/team-capacity": () => import("../screens/insights/TeamCapacity"),
  "/playbooks/calibration/admin": () => import("../screens/playbooks/CalibrationAdmin"),
  "/playbooks/calibration": () => import("../screens/playbooks/CalibrationRitual"),
  "/playbooks/tests/:id": () => import("../screens/playbooks/PlaybookTestDetail"),
  "/playbooks/tests": () => import("../screens/playbooks/PlaybookTests"),
  "/playbooks/editor": () => import("../screens/playbooks/PlaybookEditor"),
  "/playbooks": () => import("../screens/playbooks/PlaybookLeaderboard"),
  "/pipeline": () => import("../screens/pipeline/PipelineDashboard"),
  "/pipeline/queue": () => import("../screens/pipeline/DeliveryQueue"),
  "/pipeline/proposals": () => import("../screens/pipeline/ChangeProposals"),
  "/pipeline/review": () => import("../screens/pipeline/ReviewCenter"),
  "/pipeline/branches": () => import("../screens/pipeline/BranchHealth"),
  "/pipeline/activity": () => import("../screens/pipeline/PipelineActivity"),
  "/pipeline/system": () => import("../screens/pipeline/SystemHealth"),
  "/pipeline/security": () => import("../screens/pipeline/SecurityIntegrity"),
  "/pipeline/deployments": () => import("../screens/pipeline/Deployments"),
  "/pipeline/releases": () => import("../screens/pipeline/Releases"),
  "/pipeline/settings": () => import("../screens/pipeline/PipelineSettings"),
  "/pipeline/notifications": () => import("../screens/pipeline/PipelineNotifications"),
  "/pipeline/onboarding": () => import("../screens/pipeline/PipelineOnboarding"),
  "/pipeline/emergency": () => import("../screens/pipeline/EmergencyOps"),
  "/pipeline/compare": () => import("../screens/pipeline/Compare"),
  "/pipeline/coordination": () => import("../screens/pipeline/BranchCoordination"),
  "/admin/activity": () => import("../screens/admin/ActivityLog"),
  "/admin/sensitive": () => import("../screens/admin/SensitiveLog"),
  "/admin/users": () => import("../screens/admin/Users"),
  "/admin/servers": () => import("../screens/admin/CloudServers"),
  "/admin/webhooks": () => import("../screens/admin/Webhooks"),
  "/admin/deliveries": () => import("../screens/admin/Deliveries"),
  "/admin/plan-usage": () => import("../screens/admin/PlanUsage"),
  "/admin/plans": () => import("../screens/admin/PlansCompare"),
  "/admin/delete-my-data": () => import("../screens/admin/DeleteMyData"),
  "/admin/archive": () => import("../screens/admin/Archive"),
  "/admin/version": () => import("../screens/admin/Version"),
  "/admin/actions": () => import("../screens/admin/Actions"),
  "/admin/jobs": () => import("../screens/admin/Jobs"),
  "/access-keys": () => import("../screens/keys/AccessKeys"),
  "/admin/access-keys": () => import("../screens/admin/AccessKeysAdmin"),
  "/integrations": () => import("../screens/perimeter/Integrations"),
  "/integrations/sso": () => import("../screens/perimeter/SsoSetup"),
  "/integrations/calendar": () => import("../screens/perimeter/CalendarConnect"),
  "/integrations/custom": () => import("../screens/perimeter/CustomIntegration"),
  "/status": () => import("../screens/perimeter/StatusPage"),
  "/onboarding": () => import("../screens/auth/Onboarding"),
  "/profile": () => import("../screens/perimeter/Profile"),
  "/settings": () => import("../screens/perimeter/UserSettings"),
  "/notifications": () => import("../screens/notifications/NotificationsInboxPage"),
  "/auth/callback": () => import("../screens/auth/AuthCallback"),
  "/welcome": () => import("../screens/auth/Welcome"),
  "/reference": () => import("../screens/docs/Reference"),
  "/guide": () => import("../screens/docs/Guide"),
  "/library": () => import("../screens/library/Library"),
  "/showcase/patterns": () => import("../screens/library/PatternShowcase"),
  "/showcase/realtime": () => import("../screens/library/RealtimeShowcase"),
  "/public": () => import("../screens/docs/PublicLanding"),
};
